"use client";

import { useEffect } from 'react';
import { recordTouch } from '@/lib/utils/attribution-client';

/**
 * Фиксирует рекламное, реферальное или органическое касание при загрузке страницы.
 * Ничего не рендерит.
 */
export default function UtmTracker() {
  useEffect(() => {
    recordTouch();
  }, []);

  return null;
}
